<div class="mat-toolbar-container no-print">
  <mat-toolbar *ngIf="(permissions$ | async) as permissions" class="flex justify-content--flex-start toolbar">
    <div *ngIf="showSection('doors') && permissions?.action?.permissions?.doors?.read" [ngClass]="{'selected':isSelectedRoute('/doors')}" class="link" (click)="navigate('/doors')">
      <app-svg
      [svg]="ICON_NAMES.doors"
      class="top10 doors"
      [ngClass]="{'selected':isSelectedRoute('/users')}">
    </app-svg>

      <div class="module-text">{{'mainBar.doors' | translate}}</div>
    </div>
    <div
      *ngIf="showSection('users') &&
            (permissions?.action?.permissions?.usersAndCards?.read || permissions?.action?.permissions?.usersAndCards?.modify) &&
             (permissions?.action?.permissions?.visitors?.read || permissions?.action?.permissions?.visitors?.modify ||
             permissions?.action?.permissions?.operators?.read || permissions?.action?.permissions?.operators?.modify)"
      [ngClass]="{'selected':isSelectedRoute('/users')}"
      class="link" (click)="navigate('/users')"
    >
      <app-svg
        [svg]="ICON_NAMES.user"
        class="top10 users"
        [ngClass]="{'selected':isSelectedRoute('/users')}">
      </app-svg>
      <div class="module-text">{{'mainBar.users' | translate}}</div>
    </div>
    <div *ngIf="showSection('lockdown') &&  permissions?.action?.permissions?.lockdown?.read" [ngClass]="{'selected':isSelectedRoute('/lockdown')}" class="link" (click)="navigate('/lockdown')">
      <app-svg [svg]="ICON_NAMES.lock_shield" class="top10 lockdown"
               [ngClass]="{'selected':isSelectedRoute('/lockdown')}"></app-svg>
      <div class="module-text">{{'mainBar.lockdown' | translate}}</div>
    </div>
    <div *ngIf="showSection('events') && permissions?.action?.permissions?.events?.read" [ngClass]="{'selected':isSelectedRoute('/events')}" class="link events" (click)="navigate('/events')">
      <div class="events-icon-container">
        <div class="icon-bell" [ngClass]="{'selected':isSelectedRoute('/events')}"></div>
<!--        todo: will be supported in the future-->
<!--        <div class="unread-events">-->
<!--          <div class="unread-events-text">-->
<!--            420-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div class="module-text">{{'mainBar.events' | translate}}</div>
    </div>
    <div *ngIf="showSection('networks') && permissions?.action?.permissions?.networks?.read" [ngClass]="{'selected':isSelectedRoute('/networks')}" class="link" (click)="navigate('/networks')">
      <div class="icon-network" [ngClass]="{'selected':isSelectedRoute('/networks')}"></div>
      <div class="module-text">{{'mainBar.networks' | translate}}</div>
    </div>
    <div *ngIf="showSection('reports') && permissions?.action?.permissions?.reports?.read" [ngClass]="{'selected':isSelectedRoute('/reports')}" class="link" (click)="navigate('/reports')">
      <div class="icon-report" [ngClass]="{'selected':isSelectedRoute('/reports')}"></div>
      <div class="module-text">{{'mainBar.reports' | translate}}</div>
    </div>
  </mat-toolbar>
</div>
